import type { ComponentType } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import { useHistory, useLocation } from 'react-router-dom';
import { Redirect } from '../../router/react-router-v5-compat';
import i18n from '../../i18n';
import './scss/park-mode.page.scss';
import { HookDecorator } from '../main/main-page-states';
import ParkModeBookingTimeTabPage from './park-mode-booking-time-tab.page';
import ParkModeProjectBindingComponent from './park-mode-project-binding.component';
import ParkModeTermsTabPage from './park-mode-terms-tab.page';

/** 娱乐项目管理路由前缀 */
const PARK_MODE_BASE = '/main/rbp-cloud/park-mode';

const TAB_DEFS: {
    path: string;
    i18nKey: string;
    Component: ComponentType;
}[] = [
    { path: `${PARK_MODE_BASE}/booking-time`, i18nKey: 'park_mode_page_text_booking_time_management', Component: ParkModeBookingTimeTabPage },
    { path: `${PARK_MODE_BASE}/project-binding`, i18nKey: 'park_mode_page_text_project_binding', Component: ParkModeProjectBindingComponent },
    { path: `${PARK_MODE_BASE}/terms-setting`, i18nKey: 'park_mode_page_text_terms_setting', Component: ParkModeTermsTabPage },
];

const DEFAULT_TAB_PATH = TAB_DEFS[0].path;

/**
 * 云 RBP「娱乐项目管理」壳页：顶部 Tab 切换预订时间 / 项目绑定 / 条款设置。
 */
export default HookDecorator(() => {
    const history = useHistory();
    const { pathname } = useLocation();

    if (pathname === PARK_MODE_BASE || pathname === `${PARK_MODE_BASE}/`) {
        return <Redirect to={DEFAULT_TAB_PATH} />;
    }
    const active = TAB_DEFS.find((t) => t.path === pathname);
    if (!active) {
        return <Redirect to={DEFAULT_TAB_PATH} />;
    }

    const { Component } = active;

    return (
        <Box className="park-mode-page">
            <Tabs
                className="park-mode-page__tabs"
                value={pathname}
                onChange={(_, value: string) => history.push(value)}
                variant="scrollable"
                scrollButtons="auto"
                TabIndicatorProps={{ style: { display: 'none' } }}
            >
                {TAB_DEFS.map((t) => (
                    <Tab
                        key={t.path}
                        value={t.path}
                        disableRipple
                        label={i18n.t(t.i18nKey)}
                        className="park-mode-page__tab"
                    />
                ))}
            </Tabs>
            <Box className="park-mode-page__panel">
                <Component />
            </Box>
        </Box>
    );
});
